import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthStateService } from './services/auth-state.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
    constructor(
        public oidcSecurityService: OidcSecurityService,
        private authStateService: AuthStateService
    ) {}

    ngOnInit() {
        this.oidcSecurityService.checkAuth().subscribe({
            next: (loginResponse) => {
                const { isAuthenticated, userData, accessToken, configId } = loginResponse;

                if (!isAuthenticated) {
                    // Mark that authorization is in progress and trigger OAuth flow
                    this.authStateService.setAuthorizationInProgress(true);
                    this.oidcSecurityService.authorize();
                } else {
                    // Clear any in-progress state and mark auth check as complete
                    this.authStateService.setAuthorizationInProgress(false);
                    this.authStateService.setAuthCheckComplete(true);
                }
            },
            error: (error) => {
                console.error('Auth check failed:', error);
                // Clear any in-progress state and mark auth check as complete on error
                this.authStateService.setAuthorizationInProgress(false);
                this.authStateService.setAuthCheckComplete(true);
            },
        });

        // Listen for authentication state changes to handle OAuth callback
        this.oidcSecurityService.isAuthenticated$.subscribe({
            next: ({ isAuthenticated }) => {
                if (isAuthenticated && this.authStateService.isAuthorizationInProgress) {
                    // User successfully authenticated, clear in-progress state
                    this.authStateService.setAuthorizationInProgress(false);
                    this.authStateService.setAuthCheckComplete(true);
                }
            },
        });
    }
}
